import Step2 from '@/Classes/FollowUp/FollowUpPatint.js';
export default {
  data() {
    return {
      patientInitialAssessment: new Step2.Step2(null, null, null, null, false, null),
    };
  },
  methods: {
    goToStep3: function () {
      if (!this.patientInitialAssessment.assessmentDate) {
        this.showErrorAlert('زمان ارزیابی نمی تواند خالی باشد');
        return;
      }
      if (!this.patientInitialAssessment.consciousnessLevelId) {
        this.showErrorAlert('سطح هوشیاری نمی تواند خالی باشد');
        return;
      }
      if (!this.patientInitialAssessment.airwayId) {
        this.showErrorAlert('راه هوایی نمی تواند خالی باشد');
        return;
      }
      if (!this.patientInitialAssessment.respirationId) {
        this.showErrorAlert('تنفس نمی تواند خالی باشد');
        return;
      }
      if (!this.patientInitialAssessment.bloodCirculationId) {
        this.showErrorAlert('گردش خون نمی تواند خالی باشد');
        return;
      }
      this.patientInitialAssessment.patientId = Number(this.patientId);
      this.addPatientInitialAssessmentFunction(this.patientInitialAssessment);
    },
    patientInitialAssessmentAdded: function () {
      this.$root.$refs.FollowUpPatient.changeTab1Step(3, true);
    },
    setData: function (data) {
      this.patientInitialAssessment.consciousnessLevelId = data.consciousnessLevel
        ? data.consciousnessLevel.id
        : null;
      this.patientInitialAssessment.airwayId = data.airway ? data.airway.id : null;
      this.patientInitialAssessment.respirationId = data.respiration ? data.respiration.id : null;
      this.patientInitialAssessment.bloodCirculationId = data.bloodCirculation
        ? data.bloodCirculation.id
        : null;
      this.patientInitialAssessment.assessmentDate = data?.assessmentDate;
      if (data.isCritical == true) {
        this.patientInitialAssessment.isCritical = true;
      } else if (data.isCritical == false) {
        this.patientInitialAssessment.isCritical = false;
      } else {
        this.patientInitialAssessment.isCritical = null;
      }
    },
    backToStep1: function () {
      this.$root.$refs.FollowUpPatient.changeTab1Step(1, true);
    },
  },
};
